module.exports = __webpack_public_path__ + "img/sixuma.d42256e9.png";